<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in"/>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
  import pageSizeMixin from 'src/mixins/pageSizeMixin';
  import {mapActions } from 'vuex';
  import AuthService from 'src/services/AuthService';
  export default {
    name: 'app',
    mixins: [pageSizeMixin],
    methods: {
      ...mapActions('config', ['getConfig']),
      ...mapActions('user', ['refreshProfile']),
    },
    async created() {
      await this.getConfig()
      // On a hard reload with a valid token there is no login dispatch, so
      // refresh the profile to (re)identify the user in Help Scout Beacon.
      if (AuthService.getToken()) {
        this.refreshProfile().catch(() => {})
      }
    }
  }
</script>
<style lang="scss">

</style>
